// noinspection JSUnresolvedVariable
import swiper from 'swiper';
import 'bootstrap/js/dist/modal';
import './account/_password-strength';

(function ($, swiper) {

  const checkPassword = ($form, $pass1, $pass2) => {
    $pass1.password({
      minimumLength: 6, // minimum password length (below this threshold, the score is 0)
      useColorBarImage: true, // use the (old) colorbar image
    });
    let currentScore = 0;
    $pass1.on('password.text', (e, text, score) => {
      currentScore = score;
    });
    setTimeout(() => {
      $pass1.trigger('change');
    }, 1000);
    $form.on('submit', (event) => {
      if (currentScore < 33) {
        event.preventDefault();
        event.stopPropagation();
        alert('Votre mot de passe n\'est pas assez sécurisé');
        return false;
      }
      if ($pass1.val() !== $pass2.val()) {
        event.preventDefault();
        event.stopPropagation();
        alert('Le mot de passe et sa confirmation ne sont pas identiques, veuillez vérifier la saisie.');
        return false;
      }
    });
  };

  const $rootPasswordForm = $('.afgc-my-account--password-forgot form');
  if ($rootPasswordForm.length) {
    const $step = $rootPasswordForm.find('input[name="step"]');
    if ($step.val() === '3') {
      checkPassword($rootPasswordForm, $rootPasswordForm.find('#forgot2_password'), $rootPasswordForm.find('#forgot2_password2'));
    }
  }

  const $rootChangePasswordForm = $('.afgc-my-account--change-password form');
  if ($rootChangePasswordForm.length) {
    checkPassword($rootChangePasswordForm, $rootChangePasswordForm.find('#new_password'), $rootChangePasswordForm.find('#new_password2'));
  }

  const $rootPersonalForm = $('.afgc-my-account--personal form');
  if ($rootPersonalForm.length) {
    $rootPersonalForm.find('select.selected2').select2();
    const $directoryFields = $rootPersonalForm.find('input[id^="directory"]');
    if ($directoryFields.length) {
      const $directoryGlobal = $directoryFields.filter('#directory_is_enable');
      const $directoryOthers = $directoryFields.not('#directory_is_enable');
      console.log('$directoryGlobal', $directoryGlobal);
      console.log('$directoryOthers', $directoryOthers);
      $directoryGlobal.on('change', () => {
        if (!$directoryGlobal.prop('checked')) {
          $directoryOthers.prop('checked', false);
        } else {
          $directoryOthers.prop('checked', true);
        }
      });
      $directoryOthers.on('change', (e) => {
        const $current = $(e.target);
        if ($current.prop('checked')) {
          $directoryGlobal.prop('checked', true);
        }
      });
    }
  }

  const $rootOrderList = $('.afgc-order-list');
  if ($rootOrderList.length) {
    const $modalPayment = $('#modal-payment');
    const $modalPaymentBody = $modalPayment.find('.modal-body');

    if ($modalPayment.data('show')) {
      $modalPayment.modal({show: true});
      window.initPayment();
    }

    $modalPayment.on('show.bs.modal', function (event) {
      const $from = $(event.relatedTarget);
      if (!$from.attr('href')) {
        return;
      }
      $modalPaymentBody.html('Chargement en cours...');
      // console.log('href', $from.attr('href'), event);
      $.ajax({
        url: $from.attr('href'),
        cache: false,
        method: 'GET',
        dataType: 'json',
        success: (data) => {
          // console.log('data', data);
          $modalPaymentBody.html(data.display);
          window.initPayment();
        },
        // error: (jqXHR, textStatus) => {
        // console.log('data error', jqXHR, textStatus);
        // }
      });
    });
  }
  //
  // const $formPassword = $('form#change-password');
  // if ($formPassword) {
  //   // TODO
  // }
  //
  // const $formEmail = $('form#change-email');
  // if ($formEmail) {
  //   // TODO
  // }
  new swiper('.my-events .swiper-container', {
    direction: 'vertical',
    slidesPerView: 2,
    // spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
})(jQuery, swiper);
